<template>
  <div id='top'>
    <project-error v-if='hasError'></project-error>
    <project-finished v-else-if='hasFinished'></project-finished>
    <project-progress v-else-if='projectIsRunning'></project-progress>
    <no-project-running v-else></no-project-running>
  </div>
</template>

<script>
  import { DateTime } from 'luxon'
  import ProjectProgress from './project-progress'
  import ProjectError from './project-error'
  import ProjectFinished from './project-finished'
  import NoProjectRunning from './no-project-running'

  export default {
    name: 'main-view',
    components: {
      ProjectProgress,
      ProjectError,
      ProjectFinished,
      NoProjectRunning
    },
    computed: {
      hasError() {
        for( var b in this.$store.state.boards ) {
          for( var sk in b.sockets ) {
            if( sk.status === 'abort') {
              return true
            }
          }
        }
        return false
      },
      secsSinceHeartbeat() {
        var now = DateTime.local()
        return Math.ceil( now.diff(this.$store.state.heartbeat) / 1000 )
      },
      hasFinished() {
        var ps = this.$store.state.counters
        if(ps.source.current < ps.source.total){
          return false
        }
        var running = false
        this.$store.state.boards.forEach((b) => {
          running = running || b.running
        })
        return !running
      },
      projectIsRunning() {
        return this.secsSinceHeartbeat < 86400
      }
    }
  }
</script>

<style scoped>
#top {
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// main-view.vue?7d042bad